import { stringify } from 'querystring';
import { AfterViewInit, Component, ElementRef, OnInit, Output, ViewChild, } from '@angular/core';
//import { NgwWowService } from 'ngx-wow';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { HttpParams } from '@angular/common/http';
import { CommonService } from 'src/app/services/common.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
import { AdvanceGridviewComponent } from 'src/app/shared/components/advance-gridview/advance-gridview.component';
import { FormControl, FormGroup } from '@angular/forms';
import { filter } from 'rxjs/operators';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

declare var $: any, bootstrap: any;
import * as c3 from 'c3';
@Component({
  selector: 'app-control-panel-lite',
  templateUrl: './control-panel-lite.component.html',
  styleUrls: ['./control-panel-lite.component.css']
})
export class ControlPanelLiteComponent implements OnInit, AfterViewInit {
  lstProcessData: any[] = [];
  lstProcessQueue: any[] = [];
  lstProcessForTiles: any[] = [];
  lstDocumentQueue = [];
  isInvoiceListVisible: boolean = false;
  lstStatDropProcess = { documentList: [] };
  lstStatDropDocument = { processList: [] };

  lstTransaction: any[] = [];
  lstTransaction_download: any[] = [];

  lstHeaders = [];
  lstHeaders_log = [];
  lstTransaction_search: any[] = [];
  lstHeader_search: any[] = [];
  selectedTileDetails: any = [];

  ProcessList = [];

  frmFilterSearch: FormGroup;

  searchURN: string = '';
  advanceSearchSummaryFields: any = [];
  advanceSearchFilterFields: any = [];



  advanceSearchSummaryStaticFields: any = {
    URN: "",
    Priority: "",
    SOURCE: "",
    FROM_EMAIL: "",
    Created_Dt_From: "",
    Created_Dt_To: ""
  };

  //advanceSearchFilterFieldsData = {};

  isDisplayTransactionData = false;
  isDisplaySearchBox = false;
  isDisplaySearchGrid = false;
  showAllBx: boolean = false;
  showStatDrop: boolean = false;
  flipProcess = false;

  lstWorkListFilter: any = [];
  selectedWorklistId: number = 0;
  lstDocumentTypeFilter: any = [];
  filteredDoctypes: any = [];
  filteredQueue = [];

  activeProcess: number = 0;
  processName: string = '';
  activeDocument: number = 0;
  selectedDocument: string = '';
  viewType: string = 'TABULAR';
  sortColumnInfo = { name: '', isOrderAsc: true };

  selectedCellIndex: number = -1;
  selectedRowIndex: number = -1;
  saveAsDefaultFilter: boolean = false;
  currentPage: any = 1;
  recordsperPage: any = 50;
  countStickyGridWidth: number = 200;
  approvalQueryCount: number = 1;

  txtURN: string = '';
  txtInputFrom: string = '';
  txtInputType: string = '';
  ddlPriority: string = '';
  isDateRangeHasValue = false;
  maxDate = new Date();
  TileName: any = ''
  TileValue: any = ''
  getmyideas: number = 0;
  invoiceCreationDateRange = new FormGroup({
    start_date: new FormControl(),
    end_date: new FormControl(),
  });

  isOpenAdvanceSearch: boolean = false;

  lstPriority: any = [
    { value: '', text: 'All' },
    { value: 'NORMAL', text: 'Normal' },
    { value: 'HiGH', text: 'High' },
  ]

  //invoiceallocate: string='';
  invoiceallocate_po: number = 0;
  invoiceallocate_nonpo: number = 0;
  //invooicecommanpool:string;
  invooicecommanpool_po: number = 0;
  invooicecommanpool_nonpo: number = 0;
  total: number;
  IsallocatedPOselected: boolean = false;
  IsallocatedNonPOselected: boolean = false;
  IsCommanPoolPOselected: boolean = false;
  IsCommanPoolNonPOselected: boolean = false;
  IsAllocatedEnabled: boolean = false;
  IsCommonpoolEnable: boolean = false;


  selfideas: number = 0;
  implementableideas: number = 0;

  New_Invoices: number = 0;
  Indexing: number = 0;
  Pending_Approval: number = 0;
  Approved: number = 0;
  AwaitingApproval: number = 0;
  Ready_for_posting: number = 0;
  Posted: number = 0;
  Finance_Review: number = 0;
  BackTo_Initiator: number = 0;
  SME_Response: number = 0;
  Need_Revalidation: number = 0;
  SME_Query: number = 0;
  TPM_Query: number = 0;
  Implementable: number = 0;
  TPM_Response: number = 0;
  SME_Review: number = 0;
  Gathering_Requirements: number = 0;
  Development: number = 0;
  UAT: number = 0;
  Deployed_Production: number = 0;
  Benefit_Realization: number = 0;
  is_implementor: boolean = false;
  Ex_On_Hold: number = 0;
  Ex_Potential_duplicate: number = 0;
  Ex_Exception: number = 0;
  Ex_Trash: number = 0;
  Ex_QueryRaised: number = 0;
  FinalTitle: string = '';
  inVoiceDetails = [];
  Project_id: number = 0;
  IsContractView: boolean = false;
  IsPoweringIdea: boolean = false;
  IsWorleyIdea: boolean = false;
  @ViewChild('processData') processData: ElementRef;
  @ViewChild('stateDrop') stateDrop: ElementRef;
  @ViewChild('page_section') public pageSection: ElementRef;
  @ViewChild('summary_grid') public summaryGrid: ElementRef;
  @ViewChild('selectedCountTd') selectedCountTd: ElementRef<HTMLElement>;
  @ViewChild('countStickyTable') countStickyTable: ElementRef<HTMLElement>;
  @ViewChild('gridTransactionData') gridTransactionData: AdvanceGridviewComponent;
  @ViewChild('filterOptionModal') filterOptionModal: ElementRef;

  modalReference: any;
  currentdoc: any;
  currentprocess: any;
  backflag: boolean;
  pageflag: boolean = true;
  constructor(private dataService: DataService, public commonService: CommonService,
    private route: Router, private modalService: NgbModal, private encryptDecryptservice: EncryptDecryptService,private memorystore: MemoryStorageService) {

    if (route.getCurrentNavigation().extras.state != undefined) {
      this.backflag = true;
    }
  }

  async ngOnInit(): Promise<void> {

    // this.isOpenAdvanceSearch = JSON.parse(this.commonService.getUserInfoFromLocalStorage('isOpenAdvanceSearch'));
    this.isOpenAdvanceSearch = JSON.parse(this.memorystore.getItem('isOpenAdvanceSearch'));
    this.Project_id = this.commonService.selectedProject;
    debugger;
    if (this.commonService.selectedRole == 244) // for  implementor
    {
      this.is_implementor = true;
    }
    if (this.Project_id == 14 || this.Project_id == 27 || this.Project_id == 23 || this.Project_id == 26)
      this.IsContractView = true;
    debugger;
    await this.getProcessList();
    await this.getDocumentTypes();

    await this.onPageLoadFilterHistory()
    //await this.onSelectFilterQueue(0);
    await this.getDashboardFilter();

    if (this.filteredDoctypes == undefined || this.filteredDoctypes.length == 0) {
      await this.onSelectFilterDocument(0);
    }
    debugger;
    await this.getMyIdeas();
    debugger;

    debugger;
    await this.getImplementable();
    debugger;
    this.approvalQueryCount = 0  ///added to comment the below line as suggested by Arun
    //this.getApprovalQueryCount();
    await this.onTileClick('Common Pool', 1, 'Common Pool Powering Idea');
    await this.getProcessData();


  }
  async getProcessList() {
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('role_id', this.commonService.selectedRole);
    params = params.append('subgroup_id', this.commonService.selectedSubgroup);

    await this.dataService.getDataPromise('process', params).then(res => {
      if (res != null) {
        if (res.success == true) {
          this.ProcessList = res.data;
        }
      }
    });
  }
  async getDocumentTypes() {

    this.lstDocumentTypeFilter = [];

    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    // params = params.append('role_id', this.commonService.selectedRole);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('subgroup_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup));
    params = params.append('role_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole));
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    await this.dataService.getDataPromise('document-types', params).then(res => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          for (var i = 0; i < res.data.length; i++) {
            this.lstDocumentTypeFilter.push({
              documentId: res.data[i].document_type_id,
              documentName: res.data[i].document_type_name,
              count: 0
            });
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  async getImplementable() {
    debugger;
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('role_id', this.commonService.selectedRole);
    params = params.append('document_type_ids', this.filteredDoctypes.toString());
    params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    // params = params.append('user_id', this.commonService.getUserInfoFromLocalStorage('userId'));
    params = params.append('user_id', this.memorystore.getItem('userId'));
    debugger;
    await this.dataService.getDataPromise('Implementable', params).then(res => {
      if (res != null) {
        debugger;
        if (res.success == true) {
          debugger;
          this.implementableideas = res.data[0].TOT_IDIEA;
        }
      }
    });
  }

  async getMyIdeas() {
    //debugger;
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('role_id', this.commonService.selectedRole);
    params = params.append('document_type_ids', this.filteredDoctypes.toString());
    params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    // params = params.append('user_id', this.commonService.getUserInfoFromLocalStorage('userId'));
    params = params.append('user_id', this.memorystore.getItem('userId'));
    //debugger;
    let bodydata = {
      project_id: this.commonService.selectedProject,
      role_id: this.commonService.selectedRole,
      document_type_ids: this.filteredDoctypes.toString(),
      subgroup_id: this.commonService.selectedSubgroup,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId')
      user_id: this.memorystore.getItem('userId')
    }
    //changed getDataPromise to postDataPromise
    await this.dataService.postDataPromise('MyIdeas', bodydata, null).then(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        //debugger;
        if (res.success == true) {
          //debugger;
          this.getmyideas = res.data[0].TOT_IDIEA;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      });
  }



  ngAfterViewInit() {
    // this.activeDocument = this.commonService.getUserInfoFromLocalStorage('dash_docTypeId');
    // this.activeProcess = this.commonService.getUserInfoFromLocalStorage('dash_processId');
    // this.currentPage = this.commonService.getUserInfoFromLocalStorage("transactionSummary_CurrentPage");
    // this.recordsperPage = this.commonService.getUserInfoFromLocalStorage("transactionSummary_RecordsPerPage");
    this.activeDocument = this.memorystore.getItem('dash_docTypeId');
    this.activeProcess = this.memorystore.getItem('dash_processId');
    this.currentPage = this.memorystore.getItem("transactionSummary_CurrentPage");
    this.recordsperPage = this.memorystore.getItem("transactionSummary_RecordsPerPage");
    this.currentPage = this.currentPage == null ? 1 : this.currentPage;
    this.recordsperPage = this.recordsperPage == null ? 50 : this.recordsperPage;
    this.recordsperPage = +this.recordsperPage;
    // this.selectedWorklistId = this.commonService.getUserInfoFromLocalStorage('dashbordSelectedWorklist');
    this.selectedWorklistId = this.memorystore.getItem('dashbordSelectedWorklist');
    setTimeout(() => {
      let el: HTMLElement = this.selectedCountTd ?.nativeElement;
      el ?.click();

      this.countStickyGridWidth = this.countStickyTable.nativeElement.offsetWidth;
    }, 2000);

    if (this.backflag == true) {
      // let doc = JSON.parse(this.commonService.getUserInfoFromLocalStorage('dash_doc_type_obj'));
      // let process = JSON.parse(this.commonService.getUserInfoFromLocalStorage('dash_process_type_obj'));
      let doc = JSON.parse(this.memorystore.getItem('dash_doc_type_obj'));
      let process = JSON.parse(this.memorystore.getItem('dash_process_type_obj'));
      this.pageflag = true;
      this.getSummaryData(doc, process)
      this.backflag = false
    }

  }

  getApprovalQueryCount() {
    this.approvalQueryCount = 0;
    let params = new HttpParams();
    this.dataService.getData('approval-query-count', params).subscribe(res => {
      if (res != null && res.success == true) {
        this.approvalQueryCount = res.data[0].count;
      }
    });
  }





  async onPageLoadFilterHistory() {
    // let dgSsearchColumns = this.commonService.getUserInfoFromLocalStorage('dashbordGridAdvanceSearchField');
    let dgSsearchColumns = this.memorystore.getItem('dashbordGridAdvanceSearchField');
    if (dgSsearchColumns != null && dgSsearchColumns != '') {
      this.advanceSearchFilterFields = JSON.parse(dgSsearchColumns);
    }

    // let dashboard_filters_string = this.commonService.getUserInfoFromLocalStorage('dashboard_filters');
    let dashboard_filters_string = this.memorystore.getItem('dashboard_filters');
    if (dashboard_filters_string != undefined && dashboard_filters_string != '') {

      let df = JSON.parse(dashboard_filters_string);
      // df = df.find(x => x.project_id == this.commonService.getUserInfoFromLocalStorage('projectId'));
      df = df.find(x => x.project_id == this.memorystore.getItem('projectId'));
      if (df != undefined && df != null) {
        if (df.filter_document != undefined && df.filter_document != '') {
          this.filteredDoctypes = df.filter_document.trim().split(',');
          this.filteredDoctypes = this.filteredDoctypes.map((i) => Number(i));
        }

        if (df.filter_queue != undefined && df.filter_queue != '') {
          this.filteredQueue = df.filter_queue.trim().split(',');
          this.filteredQueue = this.filteredQueue.map((i) => Number(i));
        }
      }
    }

    // let dashbordSelectedWorklist = this.commonService.getUserInfoFromLocalStorage('dashbordSelectedWorklist');
    let dashbordSelectedWorklist = this.memorystore.getItem('dashbordSelectedWorklist');
    if (dashbordSelectedWorklist != '' && dashbordSelectedWorklist != null) {
      this.selectedWorklistId = dashbordSelectedWorklist;
    }

    return true;
  }

  async getDashboardFilter() {

    this.isDisplayTransactionData = false;
    let searchColumns = {};

    this.advanceSearchFilterFields.forEach((field) => {
      if (field.search_value != '') {
        if (field.control_type == 'DATE') {
          searchColumns[field.db_column_name] = this.commonService.dateFormating(field.search_value);
        }
        else {
          searchColumns[field.db_column_name] = field.search_value.toString();
        }
      }
    });

    let reqData = {
      project_id: this.commonService.selectedProject,
      role_id: this.commonService.selectedRole,
      subgroup_id: this.commonService.selectedSubgroup.toString(),
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      document_type_ids: this.filteredDoctypes.toString(),
      process_queue_ids: this.filteredQueue.toString(),
      search_columns: searchColumns,
    };
    await this.dataService.postDataPromise('dashboard-filter', reqData, null).then(res => {

      if (res != null && res != undefined && res.data != null) {

        this.lstWorkListFilter = [];
        if (res.data.length > 0) {

          this.lstWorkListFilter = res.data;
          let allocated: any;
          let commanpool: any;

          //let doc = x.documents.find((f) => f.document_type_id == d);

          if (this.lstWorkListFilter.findIndex((x) => x.worklist_text == 'Allocated') > -1) {

            allocated = this.lstWorkListFilter.find((f) => f.worklist_text == 'Allocated');
            this.invoiceallocate_po = allocated.documents[0].document_count;
            this.invoiceallocate_nonpo = allocated.documents[1] == undefined ? 0 : allocated.documents[1].document_count;
            this.IsAllocatedEnabled = true;

          }

          if (this.lstWorkListFilter.findIndex((x) => x.worklist_text == 'Common Pool') > -1) {

            commanpool = this.lstWorkListFilter.find((f) => f.worklist_text == 'Common Pool');

            this.invooicecommanpool_po = commanpool.documents[0].document_count;
            this.invooicecommanpool_nonpo = allocated.documents[1] == undefined ? 0 : allocated.documents[1].document_count;
            this.IsCommonpoolEnable = true;
          }
          this.total = this.invoiceallocate_po + this.invoiceallocate_nonpo + this.invooicecommanpool_po + this.invooicecommanpool_nonpo
          this.selectedWorklistId = this.lstWorkListFilter[0].worklist_id;
          // this.commonService.setUserInfoToLocalStorage('dashbordSelectedWorklist', this.selectedWorklistId);
          this.memorystore.setItem('dashbordSelectedWorklist', this.selectedWorklistId);
        }
        this.fillDocumentTypeFilter();
      }
    });
  }

  async getProcessData() {
    this.isDisplayTransactionData = false;
    let searchColumns = {};

    // this.advanceSearchFilterFields.forEach((field) => {
    //   if (field.search_value != '') {
    //     if (field.control_type == 'DATE') {
    //       searchColumns[field.db_column_name] = this.commonService.dateFormating(field.search_value);
    //     }
    //     else {
    //       searchColumns[field.db_column_name] = field.search_value.toString();
    //     }
    //   }
    // });

    let priority = [];
    if (this.ddlPriority != "") {
      priority.push(this.ddlPriority)
    }

    let reqData = {
      project_id: this.commonService.selectedProject,
      role_id: this.commonService.selectedRole,
      subgroup_id: this.commonService.selectedSubgroup.toString(),
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      document_type_ids: this.filteredDoctypes.toString(),
      process_queue_ids: this.filteredQueue.toString(),
      worklist_id: this.selectedWorklistId,
      search_columns: searchColumns,
      urn: this.txtURN,
      priority: priority,
      source: this.txtInputType,
      from_email: this.txtInputFrom,
      selfideas: this.selfideas
    };

    if (this.commonService.readInput(this.commonService.dateFormating(this.invoiceCreationDateRange.value.start_date)) != "" && this.commonService.readInput(this.commonService.dateFormating(this.invoiceCreationDateRange.value.end_date)) != "")
      reqData['date_range'] = { "start_date": this.commonService.dateFormating(this.invoiceCreationDateRange.value.start_date), "end_date": this.commonService.dateFormating(this.invoiceCreationDateRange.value.end_date) };
    debugger;
    if (this.selectedWorklistId != null && this.selectedWorklistId > 0) {
      await this.dataService.postDataPromise('dashboard-quick-view', reqData, null).then((res) => {

        this.lstProcessData = res.data;
        this.lstProcessForTiles = [];
        this.lstProcessForTiles = res.data;
        if (this.lstProcessData == undefined || this.lstProcessData == null || this.lstProcessData.length == 0) {
          //this.commonService.showMessageBox('No data found.', 'Information');
          //return;
        }

        this.fillProcessQueue();
      });
    }

  }

  fillProcessQueue() {
    //Generates the lstProcessQueue data
    debugger;
    this.lstProcessQueue = [];

    this.lstProcessData.forEach((x) => {
      if (this.lstProcessQueue.findIndex((a) => a.ProcessId == x.process_id) == -1) {
        let lstDoc = [];
        let processCount = 0;

        this.filteredDoctypes.forEach((d) => {
          if (d != 0) {
            let doc = x.documents.find((f) => f.document_type_id == d);
            if (doc != null && doc != undefined) {
              lstDoc.push({
                documentId: d,
                documentName: doc.document_type_name,
                count: doc.document_count,
              });
              processCount += doc.document_count;
            } else {
              let fDoc = this.lstDocumentTypeFilter.find((dl) => dl.documentId == d)
              if (fDoc != null && fDoc != undefined) {
                let doc_name = fDoc.documentName;
                lstDoc.push({
                  documentId: d.documentId,
                  documentName: doc_name,
                  count: 0,
                });
              }
            }
          }
        });
        debugger;
        this.lstProcessQueue.push({
          processId: x.process_id,
          processName: x.process_name,
          count: processCount,
          documentList: lstDoc,
        });
      }
    });

    //Generates document queue
    this.lstDocumentQueue = [];

    this.filteredDoctypes.forEach((d) => {
      if (d != 0) {
        let lstProc = [];
        let docCount = 0;
        debugger;
        this.lstProcessData.forEach((p) => {
          let doc = p.documents.find((f) => f.document_type_id == d);
          if (doc != null && doc != undefined) {
            lstProc.push({
              processId: p.process_id,
              processName: p.process_name,
              count: doc.document_count,
            });
            docCount += doc.document_count;
          } else {
            lstProc.push({
              processId: p.process_id,
              processName: p.process_name,
              count: 0,
            });
          }
        });

        let fDoc = this.lstDocumentTypeFilter.find((dl) => dl.documentId == d);
        if (fDoc != null && fDoc != undefined) {
          let doc_name = fDoc.documentName
          this.lstDocumentQueue.push({
            documentId: d,
            documentName: doc_name,
            count: docCount,
            processList: lstProc,
          });
        }

      }
    });

    debugger;
    if (this.Project_id == 5) {
      this.filldata();
    }
    else if (this.Project_id == 23 || this.Project_id == 26) {
      this.IsPoweringIdea = true;
      this.IsWorleyIdea = false;
      this.filldata_PI_Idea();
    }
    else if (this.Project_id == 27) {
      this.IsPoweringIdea = false;
      this.IsWorleyIdea = true;
      this.filldata_Worley();
      this.IsWorleyIdea = true;
    }
    else {
      // this.IsPoweringIdea=false;
      // this.IsWorleyIdea=false;  
      //this.filldata_Worley();   
    }



  }

  getTransaction(doc: any, process: any, downloadflag: boolean) {
    this.currentdoc = doc;
    this.currentprocess = process;
    //this.isDisplayTransactionData = false;

    if (downloadflag == true) {
      this.lstTransaction_download = [];
    }
    else {
      this.lstHeaders = [];
      this.lstTransaction = [];
    }


    let searchColumns = {};

    this.advanceSearchSummaryFields.forEach((field) => {
      if (field.search_value != '') {
        if (field.control_type == 'DATE') {
          field.search_value = this.commonService.dateFormating(
            field.search_value
          );
        }
        searchColumns[field.db_column_name] = field.search_value.toString();
      }
    });

    // this.commonService.setUserInfoToLocalStorage('transactionGridSearchField', JSON.stringify(this.advanceSearchSummaryFields));
    // this.commonService.setUserInfoToLocalStorage('dashbordSelectedWorklist', this.selectedWorklistId);
    this.memorystore.setItem('transactionGridSearchField', JSON.stringify(this.advanceSearchSummaryFields));
    this.memorystore.setItem('dashbordSelectedWorklist', this.selectedWorklistId);

    let parentSearchField = this.advanceSearchSummaryStaticFields;
    let priority = [];
    if (parentSearchField.Priority != "") {
      priority.push(parentSearchField.Priority)
    }


    let reqData = {
      project_id: this.commonService.selectedProject,
      role_id: this.commonService.selectedRole,
      subgroup_id: this.commonService.selectedSubgroup,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      worklist_id: this.selectedWorklistId,
      document_type_ids: this.currentdoc.documentId.toString(),
      process_id: this.currentprocess.processId,
      search_columns: searchColumns,
      urn: "",
      priority: [],
      source: "",
      from_email: "",
      date_range: null,
      currentpage: this.currentPage,
      recordsperPage: this.recordsperPage,
      downloadflag: downloadflag,
      selfideas: this.selfideas
    };
    if (this.commonService.readObject(parentSearchField) != null) {
      reqData.urn = parentSearchField.URN;
      if (reqData.urn != "") {
        searchColumns["d.urn"] = reqData.urn;
      }
      reqData.priority = priority;
      reqData.source = parentSearchField.SOURCE;
      reqData.from_email = parentSearchField.FROM_EMAIL;
      if (this.commonService.readInput(parentSearchField.Created_Dt_From) != "" && this.commonService.readInput(parentSearchField.Created_Dt_To) != "")
        reqData.date_range = { "start_date": parentSearchField.Created_Dt_From, "end_date": parentSearchField.Created_Dt_To };
    }

    this.dataService.postData('dashboard-details', reqData).subscribe((res) => {
      if (res != null && res != undefined && res.data != null && res.data.length > 0) {

        if (downloadflag == true) {
          if (res.data[0].table_data.length == 0) {
            this.commonService.showMessageBox('No ideas(s) found.');
            return;
          }
          else {

            this.lstTransaction_download = res.data[0].table_data;

            this.lstTransaction_download.forEach(function (x) { delete x.RowNo; delete x.TotalRecordsCount; });

            this.commonService.exportAsExcelFile(this.lstTransaction_download, 'transaction-summary');
          }
        }
        else {
          if (res.data[0].table_data.length == 0) {
            this.commonService.showMessageBox('No Idea(s) found.');
            return;
          }

          this.lstHeaders = res.data[0].table_sections;
          this.lstHeaders_log.forEach(sec => {
            sec.section_fields.forEach(f => {
              let field = this.lstHeaders.find(x => x.section_name == sec.section_name) ?.section_fields.find(y => y.name == f.name);
              if (field) {
                field.is_visible = f.is_visible;
              }
            });
          });

          debugger;
          this.lstTransaction = res.data[0].table_data;
          this.isDisplayTransactionData = true;
          debugger;
          setTimeout(() => {
            this.pageSection.nativeElement.scrollTop = this.summaryGrid.nativeElement.offsetTop;
          }, 500);
        }

      }
    });
  }

  public startCarousel() {
    $('.docCarousel').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 2
        },
        1000: {
          items: 4
        }
      }
    })
  }
  public stopCarousel() {
    var owl = $('.docCarousel');
    owl.trigger('destroy.owl.carousel');
    owl.addClass('off');
  }
  getSearchTransaction() {  //Quick Search

    if (this.searchURN == '' || this.searchURN == null || this.searchURN == undefined) {
      this.commonService.showMessageBox('Please enter the URN to search.', 'Alert');
      return;
    }
    else if (/\W/.test(this.searchURN) == true) {
      this.commonService.showMessageBox('Please enter only alphabet, number and underscore.', 'Alert');
      return;
    }

    this.lstHeader_search = [];
    this.lstTransaction_search = [];

    let reqData = {
      project_id: this.commonService.selectedProject,
      role_id: this.commonService.selectedRole,
      subgroup_id: this.commonService.selectedSubgroup,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      worklist_id: this.selectedWorklistId,
      document_type_ids: this.filteredDoctypes.toString(),
      process_id: 0,
      search_columns: { 'd.urn': this.searchURN.toString() },
      currentpage: 1,
      recordsperPage: 50
    };
    if (this.selectedWorklistId > 0 && this.selectedWorklistId != null) {
      this.dataService.postData('dashboard-details', reqData).subscribe((res) => {
        if (res != null && res != undefined) {

          if (res.success == false) {
            this.commonService.showMessageBox('Internal Error.<br>' + res.errorMessage);
            return;
          }
          if (res.data[0].table_data.length == 0) {
            this.commonService.showMessageBox('No invoice(s) found for entered URN value.');
            return;
          }
          this.lstHeader_search = res.data[0].table_sections;
          this.lstHeaders_log.forEach(sec => {
            sec.section_fields.forEach(f => {
              let field = this.lstHeader_search.find(x => x.section_name == sec.section_name) ?.section_fields.find(y => y.name == f.name);
              if (field) {
                field.is_visible = f.is_visible;
              }
            });
          });
          this.lstTransaction_search = res.data[0].table_data;
          this.isDisplaySearchGrid = true;
        }
      });
    }
  }

  onTransactionSummaryGridCellClick(doc: any, process: any) {

    this.currentPage = 1;
    this.recordsperPage = 50;
    // this.commonService.setUserInfoToLocalStorage("transactionSummary_CurrentPage", this.currentPage);
    // this.commonService.setUserInfoToLocalStorage("transactionSummary_RecordsPerPage", this.recordsperPage);
    this.memorystore.setItem("transactionSummary_CurrentPage", this.currentPage);
    this.memorystore.setItem("transactionSummary_RecordsPerPage", this.recordsperPage);

    this.getSummaryData(doc, process)
  }

  async getSummaryData(doc: any, process: any) {
    if (doc.count == 0 || process.count == 0) {
      this.isDisplayTransactionData = false;
      return;
    }

    this.showStatDrop = false;
    this.activeProcess = process.processId;
    this.processName = process.processName;
    this.activeDocument = doc.documentId;
    this.selectedDocument = doc.documentName;
    // this.commonService.setUserInfoToLocalStorage('dash_docTypeId', this.activeDocument);
    // this.commonService.setUserInfoToLocalStorage('dash_processId', this.activeProcess);
    // this.commonService.setUserInfoToLocalStorage('dash_doc_type_obj', JSON.stringify(doc));
    // this.commonService.setUserInfoToLocalStorage('dash_process_type_obj', JSON.stringify(process));
    this.memorystore.setItem('dash_docTypeId', this.activeDocument);
    this.memorystore.setItem('dash_processId', this.activeProcess);
    this.memorystore.setItem('dash_doc_type_obj', JSON.stringify(doc));
    this.memorystore.setItem('dash_process_type_obj', JSON.stringify(process));
    await this.getAdvanceSearchFields(true);
    this.getTransaction(doc, process, false);
  }

  async getAdvanceSearchFields(isSummarySearch: boolean) {

    let reqData = {
      project_id: this.commonService.selectedProject,
      subgroup_id: this.commonService.selectedSubgroup,
      document_type_ids: isSummarySearch ? this.activeDocument.toString() : this.filteredDoctypes.toString(),
    };

    await this.dataService.getDataPromise('advanced-search-fields', reqData).then((res) => {
      if (res != null && res.data != null) {
        if (isSummarySearch) {
          this.advanceSearchSummaryFields = res.data;
          this.advanceSearchSummaryFields.forEach(async (element) => {
            element['search_value'] = '';
            if (element.control_type == 'TEXTBOX') {
              element.value_type = element.validation_type == 'NUMERIC' ? 'number' : 'text';
            }

            if (element.control_type == 'DROPDOWN') {
              element.options = await this.commonService.getDropdownData(element.field_mapping_detail_id);
              element.options.splice(0, 0, { id: 0, name: '-- Select --' });
            }
          });
          if (this.advanceSearchFilterFields.length > 0) {
            this.advanceSearchFilterFields.forEach((element) => {
              if (this.advanceSearchSummaryFields.findIndex((x) => x.db_column_name == element.db_column_name) > -1) {
                this.advanceSearchSummaryFields.find((x) => x.db_column_name == element.db_column_name).search_value = element.search_value;
              }
            });
          }
        } else {
          this.advanceSearchFilterFields = res.data;
          this.advanceSearchFilterFields.forEach(async (element) => {
            element['search_value'] = '';
            if (element.control_type == 'TEXTBOX') {
              element.value_type = element.validation_type == 'NUMERIC' ? 'number' : 'text';
            }
            if (element.control_type == 'DROPDOWN') {
              element.options = await this.commonService.getDropdownData(element.field_mapping_detail_id);
              element.options.splice(0, 0, { id: 0, name: '-- Select --' });
            }
          });
        }
      }
    });
  }

  advanceSearchClickEvent(parentSearchField: any) {

    this.advanceSearchSummaryStaticFields = parentSearchField;
    this.getTransaction(
      {
        documentId: this.activeDocument,
        documentName: this.selectedDocument,
        count: 1,
      },
      {
        processId: this.activeProcess,
        processName: this.processName,
        count: 1,
      },
      false
    );
  }

  columnsFilterChangeEvent(lstHeaders: any) {
    this.lstHeaders_log = lstHeaders;
  }

  filterTransactionGridByLocalSearch() {
    // let locStorTransactionSearchField = this.commonService.getUserInfoFromLocalStorage('transactionGridSearchField');
    let locStorTransactionSearchField = this.memorystore.getItem('transactionGridSearchField');
    if (locStorTransactionSearchField != '') {
      this.advanceSearchSummaryFields = JSON.parse(locStorTransactionSearchField);
    }
    return true;
  }

  openFilterFieldMagnifySearchModal(fieldMappingDetailId: number, magnifyDependantFields: string = null, predefinedTableColumnName: string = 'id') {

    let dependantFieldValues = {};
    if (magnifyDependantFields != null) {
      magnifyDependantFields = JSON.parse(magnifyDependantFields);
      Object.keys(magnifyDependantFields).forEach(x => {
        let field = this.advanceSearchFilterFields.find(f => f.db_column_name == magnifyDependantFields[x]);
        if (field != undefined) {
          let field_value = field.search_value;
          if (field_value != null && field_value != '' && field_value != undefined) {
            // if (field.control_type == 'DROPDOWN') {
            //   field_value = field.options.find(d => d.id == field_value).name;
            // }
            dependantFieldValues[x] = field_value.toString();
          }
        }


      });
    }

    const modalRef = this.modalService.open(MagnifyFieldSearchComponent, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.fieldMappingDetailId = fieldMappingDetailId;
    modalRef.componentInstance.dependantFieldValues = dependantFieldValues;
    modalRef.componentInstance.predefinedTableColumnName = predefinedTableColumnName;
    modalRef.componentInstance.selectRecord.subscribe((res) => {
      const selectedField = this.advanceSearchFilterFields.find(x => x.field_mapping_detail_id == res.fieldId);
      //selectedField.search_value = res.fieldValue.toString();
      if (selectedField != null) {
        this.frmFilterSearch
          .get(selectedField.db_column_name)
          .setValue(res.fieldValue.toString());

        if (selectedField.control_type == 'DROPDOWN') {
          // if dependent field in advance search then add code here
        }
      }
      modalRef.close();

    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }

  async showFilterModel() {

    if (this.filteredQueue == undefined || this.filteredQueue.length == 0) {
      this.onSelectFilterQueue(0);
    }

    let lastAdvanceSearchFilterFields: any
    lastAdvanceSearchFilterFields = JSON.parse(JSON.stringify(this.advanceSearchFilterFields));

    await this.getAdvanceSearchFields(false);

    const formControls: any = {};
    this.advanceSearchFilterFields.forEach(async (field) => {
      let fieldValidators = [];
      let defaultValue: any = "";

      let f = lastAdvanceSearchFilterFields.find(f => f.db_column_name == field.db_column_name);
      if (f != undefined)
        defaultValue = f.search_value;
      else
        defaultValue = field.control_type == 'DATE' ? '' : field.control_type == 'DROPDOWN' ? '' : field.control_type == 'CHECKBOX' ? false : '';

      formControls[field.db_column_name] = new FormControl(defaultValue, fieldValidators);
    });

    this.frmFilterSearch = new FormGroup(formControls);

    this.showModal(this.filterOptionModal, 'lg');

  }

  async filterProcessData() {

    if (this.filteredQueue.length == 0) {
      this.commonService.showMessageBox("Please select at least one Queue.", "Message");
      return
    }

    if (this.filteredDoctypes.length == 0) {
      this.commonService.showMessageBox("Please select at least one Work Item.", "Message");
      return
    }

    this.modalReference.close();

    this.advanceSearchFilterFields.forEach(field => {
      if (this.frmFilterSearch.get(field.db_column_name).value != '') {
        field.search_value = this.frmFilterSearch.get(field.db_column_name).value;
      }
    });

    // this.commonService.setUserInfoToLocalStorage('dashbordGridAdvanceSearchField', JSON.stringify(this.advanceSearchFilterFields));
    this.memorystore.setItem('dashbordGridAdvanceSearchField', JSON.stringify(this.advanceSearchFilterFields));
    // let dashboard_filters = this.commonService.getUserInfoFromLocalStorage('dashboard_filters');
    let dashboard_filters = this.memorystore.getItem('dashboard_filters');
    if (dashboard_filters == '' || dashboard_filters == undefined) {
      dashboard_filters = [];
      dashboard_filters.push({
        filter_document: (this.filteredDoctypes != null) ? this.filteredDoctypes.toString() : '',
        filter_queue: (this.filteredQueue != null) ? this.filteredQueue.toString() : '',
        // project_id: this.commonService.getUserInfoFromLocalStorage('projectId')
        project_id: this.memorystore.getItem('projectId')
      });
    }
    else {
      dashboard_filters = JSON.parse(dashboard_filters);
      // let dfilter = dashboard_filters.find(f => f.project_id == this.commonService.getUserInfoFromLocalStorage('projectId'));
      let dfilter = dashboard_filters.find(f => f.project_id == this.memorystore.getItem('projectId'));
      if (dfilter != undefined) {
        dfilter = {
          filter_document: (this.filteredDoctypes != null) ? this.filteredDoctypes.toString() : '',
          filter_queue: (this.filteredQueue != null) ? this.filteredQueue.toString() : '',
          // project_id: this.commonService.getUserInfoFromLocalStorage('projectId')
          project_id: this.memorystore.getItem('projectId')
        }

        // let index = dashboard_filters.findIndex(f => f.project_id == this.commonService.getUserInfoFromLocalStorage('projectId'));
        let index = dashboard_filters.findIndex(f => f.project_id == this.memorystore.getItem('projectId'));
        dashboard_filters[index] = dfilter;
      }
      else {
        dashboard_filters.push({
          filter_document: (this.filteredDoctypes != null) ? this.filteredDoctypes.toString() : '',
          filter_queue: (this.filteredQueue != null) ? this.filteredQueue.toString() : '',
          // project_id: this.commonService.getUserInfoFromLocalStorage('projectId')
          project_id: this.memorystore.getItem('projectId')
        });
      }
    }

    // this.commonService.setUserInfoToLocalStorage('dashboard_filters', JSON.stringify(dashboard_filters));
    this.memorystore.setItem('dashboard_filters', JSON.stringify(dashboard_filters));
    //Save filter criteria in database
    if (this.saveAsDefaultFilter)
      this.saveFilter(dashboard_filters);

    this.saveAsDefaultFilter = false;

    await this.getDashboardFilter();
    await this.getProcessData();
  }

  saveFilter(filters: any) {
    let reqData = {
      // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
      user_id: Number(this.memorystore.getItem('userId')),
      filters: JSON.stringify(filters)
    };

    this.dataService.postData('save-dashboard-filter', reqData).subscribe(res => {
    });
  }

  async fillDocumentTypeFilter() {

    this.lstDocumentTypeFilter.forEach(d => { d.count = 0; });

    this.lstWorkListFilter.forEach((element) => {
      element.documents.forEach((d) => {
        const doc = this.lstDocumentTypeFilter.find(element => element.documentId === d.document_type_id);
        if (doc != null) {
          doc.count += d.document_count
        }
        else {
          this.lstDocumentTypeFilter.push({
            documentId: d.document_type_id,
            documentName: d.document_name,
            count: d.document_count,
          });
        }
      });
    });
  }

  getWorklistCountByDoctype(documents: any): number {
    let count = 0;
    documents.forEach((element) => {
      if (this.filteredDoctypes.includes(element.document_type_id))
        count += element.document_count;
    });
    return count;
  }

  getAllDoctypeCount(): number {
    let count = 0;
    this.lstDocumentTypeFilter.forEach((element) => {
      count += element.count;
    });
    return count;
  }

  clearSearch() {
    if (
      this.searchURN == '' ||
      this.searchURN == null ||
      this.searchURN == undefined
    ) {
      this.isDisplaySearchGrid = false;
      this.lstHeader_search = [];
      this.lstTransaction_search = [];
    } else {
      this.getSearchTransaction();
    }
  }

  onIconSearchClick() {
    if (this.isDisplaySearchBox == false) {
      this.isDisplaySearchBox = true;
    } else {
      this.isDisplaySearchBox = false;
      this.isDisplaySearchGrid = false;
      this.lstHeader_search = [];
      this.lstTransaction_search = [];
      this.searchURN = '';
    }
  }

  async onSelectFilterDocument(doctypeId: any) {
    if (doctypeId == 0 && this.filteredDoctypes.includes(0)) {
      this.filteredDoctypes = [];

    } else if (doctypeId == 0) {
      this.filteredDoctypes = [0];
      this.lstDocumentTypeFilter.forEach((element) => {
        this.filteredDoctypes.push(element.documentId);
      });

    } else if (this.filteredDoctypes.includes(doctypeId)) {
      this.filteredDoctypes = this.filteredDoctypes.filter((d) => d != doctypeId && d != 0);

    } else if (doctypeId != -1) {
      this.filteredDoctypes.push(doctypeId);
      if (this.filteredDoctypes.length == this.lstDocumentTypeFilter.length) {
        this.filteredDoctypes.push(0);
      }
    }
    await this.getAdvanceSearchFields(false);
  }

  async onSelectFilterQueue(processId: any) {
    debugger;
    if (processId == 0 && this.filteredQueue.includes(0)) {
      this.filteredQueue = [];
    } else if (processId == 0 && this.filteredQueue.length == 0) {
      this.filteredQueue = [];
      this.ProcessList.filter(p => p.process_module != 'END PROCESS').forEach((p) => {
        this.filteredQueue.push(p.process_id);
      });
      //For Xerox below code should be uncommented
      //this.ProcessList.forEach((p) => {
      // this.filteredQueue.push(p.process_id);
      //});
    }
    else if (processId == 0) {
      this.filteredQueue = [];
      this.filteredQueue.push(0);
      this.ProcessList.forEach((p) => {
        this.filteredQueue.push(p.process_id);
      });
    } else if (this.filteredQueue.includes(processId)) {
      this.filteredQueue = this.filteredQueue.filter((p) => p != processId && p != 0);
    }
    else {
      this.filteredQueue.push(processId);
      if (this.filteredQueue.length == this.ProcessList.length) {
        this.filteredQueue.push(0);
      }
    }
  }

  async onSelectFilterWorkList(workListId: number) {
    this.selectedWorklistId = workListId;
    // this.commonService.setUserInfoToLocalStorage('dashbordSelectedWorklist', this.selectedWorklistId);
    this.memorystore.setItem('dashbordSelectedWorklist', this.selectedWorklistId);
    await this.getProcessData();
    // await this.getDashboardFilter();
    // await this.filterProcessData();

  }

  downloadalldata(param: any) {
    // let doc = JSON.parse(this.commonService.getUserInfoFromLocalStorage('dash_doc_type_obj'));
    // let process = JSON.parse(this.commonService.getUserInfoFromLocalStorage('dash_process_type_obj'));
    let doc = JSON.parse(this.memorystore.getItem('dash_doc_type_obj'));
    let process = JSON.parse(this.memorystore.getItem('dash_process_type_obj'));
    this.getTransaction(doc, process, true)


  }

  cellClickEvent(param: any) {


    if (param.columnName.toLowerCase() == 'urn') {
      // this.commonService.setUserInfoToLocalStorage('documentDetailId', param.rowData['DOCUMENT_DETAIL_ID']);
      this.memorystore.setItem('documentDetailId', param.rowData['DOCUMENT_DETAIL_ID']);
      if (param.hasOwnProperty('nextRowDataIDs') && param['nextRowDataIDs'] != null) {
        // this.commonService.setUserInfoToLocalStorage('nextDocumentDetailIDs', param.nextRowDataIDs);
        this.memorystore.setItem('nextDocumentDetailIDs', param.nextRowDataIDs);
      } else {
        // this.commonService.setUserInfoToLocalStorage('nextDocumentDetailIDs', '');
        this.memorystore.setItem('nextDocumentDetailIDs', '');
      }

      this.route.navigate(['transaction'], {
        state: { documentDetailId: param.rowData['DOCUMENT_DETAIL_ID'] },
      }).then(() => {
        //window.location.reload();
      });


    }
  }

  scrollGrid(direction: string): void {
    if (direction == 'next') {
      this.processData.nativeElement.scrollLeft += 500;
    } else {
      this.processData.nativeElement.scrollLeft -= 500;
    }
  }

  loadStatDrop(target: string, data: any, event: any = null) {
    this.stateDrop.nativeElement.style.top =
      event != null
        ? event.currentTarget.offsetTop +
        event.currentTarget.offsetHeight +
        7 +
        'px'
        : '50px';
    this.showStatDrop = true;
    this.lstStatDropProcess = { documentList: [] };
    this.lstStatDropDocument = { processList: [] };
    if (target == 'process') {
      if (this.activeProcess != data.processId) this.activeDocument = 0;
      this.activeProcess = data.processId;
      this.lstStatDropProcess = data;
    } else {
      if (this.activeDocument != data.documentId) this.activeProcess = 0;
      this.activeDocument = data.documentId;
      this.lstStatDropDocument = data;
    }
  }

  setPaginationLocalStorageEvent() {

    // this.commonService.setUserInfoToLocalStorage("transactionSummary_CurrentPage", this.gridTransactionData.currentPage);
    // this.commonService.setUserInfoToLocalStorage("transactionSummary_RecordsPerPage", this.gridTransactionData.recordsPerPage);
    this.memorystore.setItem("transactionSummary_CurrentPage", this.gridTransactionData.currentPage);
    this.memorystore.setItem("transactionSummary_RecordsPerPage", this.gridTransactionData.recordsPerPage);
    // this.currentPage = this.commonService.getUserInfoFromLocalStorage("transactionSummary_CurrentPage");
    // this.recordsperPage = this.commonService.getUserInfoFromLocalStorage("transactionSummary_RecordsPerPage");
    // let doc = JSON.parse(this.commonService.getUserInfoFromLocalStorage('dash_doc_type_obj'));
    // let process = JSON.parse(this.commonService.getUserInfoFromLocalStorage('dash_process_type_obj'));
    this.currentPage = this.memorystore.getItem("transactionSummary_CurrentPage");
    this.recordsperPage = this.memorystore.getItem("transactionSummary_RecordsPerPage");
    let doc = JSON.parse(this.memorystore.getItem('dash_doc_type_obj'));
    let process = JSON.parse(this.memorystore.getItem('dash_process_type_obj'));
    this.getTransaction(doc, process, false)
  }

  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  setDecimalPlaces(value: any, decimalPlace: number, validationType: string) {
    return validationType.toLowerCase() == 'numeric' ? parseFloat(value == '' ? 0 : value).toFixed(Number(decimalPlace)) : value;
  }

  onTextChange(field: any) {
    let value = this.frmFilterSearch.get(field.db_column_name).value;
    this.frmFilterSearch.get(field.db_column_name).setValue(this.setDecimalPlaces(value, field.precision_point, field.validation_type))
  }

  hasValue(field) {
    let v = this.frmFilterSearch.get(field.db_column_name).value;
    if (v != undefined && v != null && v != '')
      return true
    else
      return false;
  }

  clearText(field) {
    this.frmFilterSearch.get(field.db_column_name).setValue('');
  }

  onInvoiceCreationDateChanges() {
    if (
      this.invoiceCreationDateRange.value.start_date != '' ||
      this.invoiceCreationDateRange.value.end_date != ''
    ) {
      this.isDateRangeHasValue = true;
    }
  }

  openChartView() {
    this.route.navigate(["chart_dashboard"]);

  }

  resetInvoiceCreationDateRange() {
    this.invoiceCreationDateRange = new FormGroup({
      start_date: new FormControl(),
      end_date: new FormControl(),
    });
    this.isDateRangeHasValue = false;
  }
  async onTileClick(event: any, selfIdeas: any, doc: any) {
    debugger;
    this.IsallocatedPOselected = false;
    this.IsallocatedNonPOselected = false;
    this.IsCommanPoolPOselected = false;
    this.IsCommanPoolNonPOselected = false;

    switch (doc) {
      case 'Allocated Powering Idea':
        this.IsallocatedPOselected = true
        break;
      case 'Allocated Order to Cash':
        this.IsallocatedNonPOselected = true;
        break;
      case 'Common Pool Powering Idea':
        this.IsCommanPoolPOselected = true;
        break;
      case 'Common Pool Order to Cash':
        this.IsCommanPoolNonPOselected = true;
        break;
    }
    // this.isInvoiceListVisible  = true;
    // this.selectedTileDetails=[];
    // this.selectedTileDetails = event.selectedTileDetails;
    // this.TileValue =this.selectedTileDetails[0].tilecount;
    debugger;
    this.selfideas = selfIdeas;
    this.TileName = doc;
    let tile = event

    if (tile.includes('Allocated'))
      this.onSelectFilterWorkList(1)
    else
      this.onSelectFilterWorkList(2)



    //this.filldata();
    // debugger;
    // var test =this.lstProcessForTiles

  }

  async onDetailTileClick(event: any) {
    debugger;
    let doc: any; let process: any
    this.lstProcessQueue.forEach(p => {
      if (p.processName == event) {
        //p.documentList[0].documentName
        process = p;
        p.documentList.forEach(d => {
          if (d.documentName == this.FinalTitle) {
            doc = d
            return;
          }

        })

      }

    });
    this.currentPage = 1;
    this.recordsperPage = 50;
    // this.commonService.setUserInfoToLocalStorage("transactionSummary_CurrentPage", this.currentPage);
    // this.commonService.setUserInfoToLocalStorage("transactionSummary_RecordsPerPage", this.recordsperPage);
    this.memorystore.setItem("transactionSummary_CurrentPage", this.currentPage);
    this.memorystore.setItem("transactionSummary_RecordsPerPage", this.recordsperPage);
    this.getSummaryData(doc, process)
  }


  filldata() {
    //   
    //   this.inVoiceDetails=[];
    //   this.FinalTitle='';
    //   let data: any;
    //   if( this.TileName=="Allocated PO Invoice" || this.TileName=="Common Pool PO Invoice")
    //   {
    //     data=this.lstDocumentQueue.find(x=>x.documentName=='PO Invoice')
    //     this.FinalTitle='PO Invoice'

    //   }
    //   else if( this.TileName=="Allocated NON-PO Invoice" || this.TileName=="Common Pool NON-PO Invoice")
    //   {
    //      data=this.lstDocumentQueue.find(x=>x.documentName=='NON-PO Invoice')
    //      this.FinalTitle='NON-PO Invoice'
    //   }
    //   let tilename="";
    //      let tilecount=0;
    //   data.processList.forEach(element => {

    //        tilename=element.processName;
    //        tilecount=element.count;
    //        this.inVoiceDetails.push( {
    //         tilename : tilename,
    //         tilecount : tilecount

    //         });
    //       });

    //       this.Indexing=0;
    //       this.New_Invoices=0;
    //       this.Approved=0;
    //       this.Ex_On_Hold=0;
    //       this.Ex_Potential_duplicate=0;
    //       this.Ex_Trash=0;
    //       this.Ex_Exception=0;
    //       this.Ex_QueryRaised=0;
    //       this.Ready_for_posting=0;

    //       if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Indexing') > -1)
    //            this.Indexing = this.inVoiceDetails.find(x=>x.tilename=='Indexing').tilecount;

    //       if (this.inVoiceDetails.findIndex((x) => x.tilename == 'New Request') > -1)
    //            this.New_Invoices=this.inVoiceDetails.find(x=>x.tilename=='New Request').tilecount;

    //      if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Creation') > -1)
    //            this.New_Invoices=this.inVoiceDetails.find(x=>x.tilename=='Creation').tilecount;

    //       if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Approved') > -1)
    //            this.Approved=this.inVoiceDetails.find(x=>x.tilename=='Approved').tilecount;


    //       if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Sent for Approver') > -1)
    //       this.Pending_Approval=this.inVoiceDetails.find(x=>x.tilename=='Sent for Approver').tilecount;




    //      //this.Pending_Approval=this.inVoiceDetails.find(x=>x.tilename=='Approved').tilecount;

    //      //Approved
    //      //Ready for Posting
    //      if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Ready for Posting') > -1)
    //      this.Ready_for_posting = this.inVoiceDetails.find(x=>x.tilename=='Ready for Posting').tilecount;

    //      if (this.inVoiceDetails.findIndex((x) => x.tilename == 'On-Hold') > -1)
    //      this.Ex_On_Hold = this.inVoiceDetails.find(x=>x.tilename=='On-Hold').tilecount;

    //      if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Potential Duplicate') > -1)
    //      this.Ex_Potential_duplicate = this.inVoiceDetails.find(x=>x.tilename=='Potential Duplicate').tilecount;

    //      if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Trash') > -1)
    //      this.Ex_Trash = this.inVoiceDetails.find(x=>x.tilename=='Trash').tilecount;

    //      if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Exception') > -1)
    //      this.Ex_Exception = this.inVoiceDetails.find(x=>x.tilename=='Exception').tilecount;

    //      if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Query Raised') > -1)
    //      this.Ex_QueryRaised=this.inVoiceDetails.find(x=>x.tilename=='Query Raised').tilecount;





    //       //this.New_Invoices=inVoiceDetails

    // //       New_Invoices:number;
    // // Indexing:number;
    // // Pending_Approval:number;
    // // Approved:number;
    // // Ready_for_posting:number;
    // // Posted:number;

    // // Ex_On_Hold:number;
    // // Ex_Potential_duplicate:number;
    // // Ex_Exception:number;
    // // Ex_Trash:number;


  }

  filldata1() {
    //   
    //   this.inVoiceDetails=[];
    //   this.FinalTitle='';
    //   let data: any;
    //   if( this.TileName=="Allocated PO Invoice" || this.TileName=="Common Pool PO Invoice")
    //   {
    //     data=this.lstDocumentQueue.find(x=>x.documentName=='Blanket Contracts')
    //     this.FinalTitle='Blanket Contracts'

    //   }
    //   else if( this.TileName=="Allocated NON-PO Invoice" || this.TileName=="Common Pool NON-PO Invoice")
    //   {
    //      data=this.lstDocumentQueue.find(x=>x.documentName=='Small Value Contracts')
    //      this.FinalTitle='Small Value Contracts'
    //   }
    //   let tilename="";
    //      let tilecount=0;
    //   data.processList.forEach(element => {

    //        tilename=element.processName;
    //        tilecount=element.count;
    //        this.inVoiceDetails.push( {
    //         tilename : tilename,
    //         tilecount : tilecount

    //         });
    //       });

    //       this.Indexing=0;
    //       this.New_Invoices=0;
    //       this.Approved=0;
    //       this.Ex_On_Hold=0;
    //       this.Ex_Potential_duplicate=0;
    //       this.Ex_Trash=0;
    //       this.Ex_Exception=0;
    //       this.Ex_QueryRaised=0;
    //       this.Ready_for_posting=0;
    //       this.AwaitingApproval=0;
    //       this.Finance_Review=0;

    //       if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Creation') > -1)
    //       this.New_Invoices=this.inVoiceDetails.find(x=>x.tilename=='Creation').tilecount;


    //       if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Procurement Review') > -1)
    //       this.Ex_On_Hold=this.inVoiceDetails.find(x=>x.tilename=='Procurement Review').tilecount;

    //       if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Legal Review') > -1)
    //            this.Indexing = this.inVoiceDetails.find(x=>x.tilename=='Legal Review').tilecount;




    //       if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Awaiting Final Approval') > -1)
    //            this.AwaitingApproval=this.inVoiceDetails.find(x=>x.tilename=='Awaiting Final Approval').tilecount;


    //       if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Supplier Review') > -1)
    //       this.Pending_Approval=this.inVoiceDetails.find(x=>x.tilename=='Supplier Review').tilecount;

    //       if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Finance Review') > -1)
    //       this.Finance_Review=this.inVoiceDetails.find(x=>x.tilename=='Finance Review').tilecount;


    //       if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Sent back to Initiator') > -1)
    //       this.BackTo_Initiator=this.inVoiceDetails.find(x=>x.tilename=='Sent back to Initiator').tilecount;

    //       if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Approved') > -1)
    //       this.Approved = this.inVoiceDetails.find(x=>x.tilename=='Approved').tilecount;

    //       if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Rejected') > -1)
    //       this.Ex_Trash = this.inVoiceDetails.find(x=>x.tilename=='Rejected').tilecount;

    //      //this.Pending_Approval=this.inVoiceDetails.find(x=>x.tilename=='Approved').tilecount;

    //      //Approved
    //      //Ready for Posting
    //      if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Approval and Closed') > -1)
    //      this.Ready_for_posting = this.inVoiceDetails.find(x=>x.tilename=='Approval and Closed').tilecount;

    //     //  if (this.inVoiceDetails.findIndex((x) => x.tilename == 'On-Hold') > -1)
    //     //  this.Ex_On_Hold = this.inVoiceDetails.find(x=>x.tilename=='On-Hold').tilecount;

    //     //  if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Potential Duplicate') > -1)
    //     //  this.Ex_Potential_duplicate = this.inVoiceDetails.find(x=>x.tilename=='Potential Duplicate').tilecount;

    //     //  if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Trash') > -1)
    //     //  this.Ex_Trash = this.inVoiceDetails.find(x=>x.tilename=='Trash').tilecount;

    //     //  if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Exception') > -1)
    //     //  this.Ex_Exception = this.inVoiceDetails.find(x=>x.tilename=='Exception').tilecount;

    //     //  if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Query Raised') > -1)
    //     //  this.Ex_QueryRaised=this.inVoiceDetails.find(x=>x.tilename=='Query Raised').tilecount;





    //       //this.New_Invoices=inVoiceDetails

    // //       New_Invoices:number;
    // // Indexing:number;
    // // Pending_Approval:number;
    // // Approved:number;
    // // Ready_for_posting:number;
    // // Posted:number;

    // // Ex_On_Hold:number;
    // // Ex_Potential_duplicate:number;
    // // Ex_Exception:number;
    // // Ex_Trash:number;


  }

  filldata_PI_Idea() {

    this.inVoiceDetails = [];
    this.FinalTitle = '';
    let data: any;
    if (this.TileName == "Allocated Powering Idea" || this.TileName == "Common Pool Powering Idea") {
      data = this.lstDocumentQueue.find(x => x.documentName == 'Powering Idea')
      this.FinalTitle = 'Powering Idea'
    }
    else if (this.TileName == "Allocated Order to Cash" || this.TileName == "Common Pool Order to Cash") {
      data = this.lstDocumentQueue.find(x => x.documentName == 'Order to Cash')
      this.FinalTitle = 'Order to Cash'
    }

    let tilename = "";
    let tilecount = 0;
    data.processList.forEach(element => {

      tilename = element.processName;
      tilecount = element.count;
      this.inVoiceDetails.push({
        tilename: tilename,
        tilecount: tilecount

      });
    });

    this.Indexing = 0;
    this.New_Invoices = 0;
    this.Ex_On_Hold = 0;

    this.SME_Response = 0;
    this.Ex_Trash = 0;
    this.SME_Query = 0;
    this.TPM_Query = 0;
    this.Implementable = 0;
    this.TPM_Response = 0;
    this.SME_Review = 0;
    this.Gathering_Requirements = 0;
    this.Development = 0;
    this.UAT = 0;
    this.Deployed_Production = 0;

    debugger;
    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Draft Idea') > -1)
      this.New_Invoices = this.inVoiceDetails.find(x => x.tilename == 'Draft Idea').tilecount;

    debugger;
    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Hold') > -1)
      this.Ex_On_Hold = this.inVoiceDetails.find(x => x.tilename == 'Hold').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'TPM approval') > -1)
      this.Indexing = this.inVoiceDetails.find(x => x.tilename == 'TPM approval').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'SME Query') > -1)
      this.SME_Query = this.inVoiceDetails.find(x => x.tilename == 'SME Query').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'SME Review') > -1)
      this.SME_Review = this.inVoiceDetails.find(x => x.tilename == 'SME Review').tilecount;


    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'TPM Query') > -1)
      this.TPM_Query = this.inVoiceDetails.find(x => x.tilename == 'TPM Query').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Implementable') > -1)
      this.Implementable = this.inVoiceDetails.find(x => x.tilename == 'Implementable').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'TPM_Response') > -1)
      this.TPM_Response = this.inVoiceDetails.find(x => x.tilename == 'TPM Response').tilecount;


    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Design') > -1)
      this.Gathering_Requirements = this.inVoiceDetails.find(x => x.tilename == 'Design').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Development') > -1)
      this.Development = this.inVoiceDetails.find(x => x.tilename == 'Development').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'UAT') > -1)
      this.UAT = this.inVoiceDetails.find(x => x.tilename == 'UAT').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Deployed Production') > -1)
      this.Deployed_Production = this.inVoiceDetails.find(x => x.tilename == 'Deployed Production').tilecount;


    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Need Revalidation') > -1)
      this.Ex_Trash = this.inVoiceDetails.find(x => x.tilename == 'Need Revalidation').tilecount;


    //this.New_Invoices=inVoiceDetails

    //       New_Invoices:number;
    // Indexing:number;
    // Pending_Approval:number;
    // Approved:number;
    // Ready_for_posting:number;
    // Posted:number;

    // Ex_On_Hold:number;
    // Ex_Potential_duplicate:number;
    // Ex_Exception:number;
    // Ex_Trash:number;


  }

  filldata_Worley() {

    this.inVoiceDetails = [];
    this.FinalTitle = '';
    let data: any;
    if (this.TileName == "Allocated Powering Idea" || this.TileName == "Common Pool Powering Idea") {
      data = this.lstDocumentQueue.find(x => x.documentName == 'Powering Idea')
      this.FinalTitle = 'Powering Idea'
    }
    else if (this.TileName == "Allocated Order to Cash" || this.TileName == "Common Pool Order to Cash") {
      data = this.lstDocumentQueue.find(x => x.documentName == 'Order to Cash')
      this.FinalTitle = 'Order to Cash'
    }

    let tilename = "";
    let tilecount = 0;
    data.processList.forEach(element => {

      tilename = element.processName;
      tilecount = element.count;
      this.inVoiceDetails.push({
        tilename: tilename,
        tilecount: tilecount

      });
    });

    this.Indexing = 0;
    this.New_Invoices = 0;
    this.Ex_On_Hold = 0;

    this.SME_Response = 0;
    this.Ex_Trash = 0;
    this.SME_Query = 0;
    this.TPM_Query = 0;
    this.Implementable = 0;
    this.TPM_Response = 0;
    this.SME_Review = 0;
    this.Gathering_Requirements = 0;
    this.Development = 0;
    this.UAT = 0;
    this.Deployed_Production = 0;
    this.Benefit_Realization = 0;
    debugger;
    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Draft Idea') > -1)
      this.New_Invoices = this.inVoiceDetails.find(x => x.tilename == 'Draft Idea').tilecount;

    debugger;
    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Hold') > -1)
      this.Ex_On_Hold = this.inVoiceDetails.find(x => x.tilename == 'Hold').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'PL Approval') > -1)
      this.Indexing = this.inVoiceDetails.find(x => x.tilename == 'PL Approval').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'SME Approval') > -1)
      this.SME_Query = this.inVoiceDetails.find(x => x.tilename == 'SME Approval').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Send back for Review') > -1)
      this.SME_Review = this.inVoiceDetails.find(x => x.tilename == 'Send back for Review').tilecount;


    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'TPM Approval') > -1)
      this.TPM_Query = this.inVoiceDetails.find(x => x.tilename == 'TPM Approval').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Build') > -1)
      this.Implementable = this.inVoiceDetails.find(x => x.tilename == 'Build').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Business Case Submitted') > -1)
      this.TPM_Response = this.inVoiceDetails.find(x => x.tilename == 'Business Case Submitted').tilecount;


    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Design') > -1)
      this.Gathering_Requirements = this.inVoiceDetails.find(x => x.tilename == 'Design').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Business Case Approved') > -1)
      this.Development = this.inVoiceDetails.find(x => x.tilename == 'Business Case Approved').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'UAT') > -1)
      this.UAT = this.inVoiceDetails.find(x => x.tilename == 'UAT').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Go Live') > -1)
      this.Deployed_Production = this.inVoiceDetails.find(x => x.tilename == 'Go Live').tilecount;


    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Initiate Implementation') > -1)
      this.Ex_Trash = this.inVoiceDetails.find(x => x.tilename == 'Initiate Implementation').tilecount;

    if (this.inVoiceDetails.findIndex((x) => x.tilename == 'Benefit Realization') > -1)
      this.Benefit_Realization = this.inVoiceDetails.find(x => x.tilename == 'Benefit Realization').tilecount;

  }






}
